enum EditTagActions {
  SET_TAG_DATA = 'SET_TAG_DATA',
  SET_TAG_AUDIT_LOG_DATA = 'SET_TAG_AUDIT_LOG_DATA',
  SET_TAG_SHARED_AND_ACCESS_CONTROL_GROUPS = 'SET_TAG_SHARED_AND_ACCESS_CONTROL_GROUPS',
  CLEAN_DATA = 'NEW_TAG_VIEW_CLEAN_DATA',
}

export default EditTagActions;
